import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';// To use toastr
import { NgbDate, NgbModal, NgbCalendar, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ajaxservice } from '../../../../services/ajaxservice'; // Common API service for both get and post
import {ExcelService} from '../../../../services/excelservice';
import { environment } from '../../../../../environments/environment';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'kt-ticketdetails',
  templateUrl: './ticketdetails.component.html',
  styleUrls: ['./ticketdetails.component.scss']
})
export class TicketdetailsComponent implements OnInit {
  @Input() public ticket_id;
  @Input() public falg
  ticket_detail:any;
  attachment1_form: FormGroup;
  attachments_form:string;
  image_or_video: string;
  httplink:string;
  dtOptions: DataTables.Settings = {};
  firstDate: string;
  secondDate: string;
  bulk_error: string;
  bulk_succ: string;
  ticket_details: any;
  ticket_flag:boolean=false;
  name: any;
  raise_name: string;

  constructor(private ajax: ajaxservice,
    private toastr: ToastrService,
    private chRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private calendar: NgbCalendar,
    private excelservice: ExcelService) { }

  ngOnInit() {
    this.get_ticket_detail(this.ticket_id)
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        "zeroRecords": 'No Data Available'
      }}
    this.httplink = environment.image_static_ip;
  }
  later() {
    this.modalService.dismissAll();
  }
  // attachment images work by harish july8  
attachments(items,attachmentPage){
  this.excelservice.attachments(items,attachmentPage);
  this.attachment1_form =this.excelservice.attachment1_form;
}
// attachment showing work by harish july8  
downloadPdf2(pdfName,attachment1,imagetags){
  this.excelservice.downloadPdf2(pdfName,attachment1,imagetags);
  this.attachments_form=this.excelservice.attachments_form;
  this.image_or_video= this.excelservice.image_or_video;
}
// attachment showing work by harish july8 
download(Attachment,item){
  this.excelservice.download(Attachment,item);
}
// gert ticket details
get_ticket_detail(ticket_ids){
  this.bulk_error = '';
  this.bulk_succ = "";
  var url = 'get_ticket_details/?';             // api url for getting the details with using post params
  var id = "ticket_id";
  this.ajax.getdataparam(url, id, ticket_ids).subscribe((result) => {
    if (result.response.response_code == "200" || result.response.response_code == "400") {
      this.ticket_details = result.response.data[0];                                           //reloading the component Coordinator
      (this.ticket_details.raised_by_role==4)?this.raise_name='DIC':(this.ticket_details.raised_by_role==5)?this.raise_name='Manager':(this.ticket_details.raised_by_role==6)?this.raise_name='BME':(this.ticket_details.raised_by_role==7)?this.raise_name='Customer':this.raise_name='Coordinator';
      if(this.ticket_details.job_logged_name != ''){
        this.name = this.ticket_details.job_logged_name
      }
      else{
        this.name = 'Unregister'
      }
      this.ticket_flag= true;
      this.get_expiredate(result.response.data);                   //get_expiredate use on same file checking on date comparison
      this.chRef.detectChanges();
    }
  }, (err) => {
    console.log(err);                                        //prints if it encounters an error
  });
}
//get_expiredate use on same file checking on date comparison
get_expiredate(contract_data) {
  contract_data.forEach((element) => {
    var today_date = this.calendar.getToday()    // get the current date
    var year = today_date.year;                  // get the current year
    var month = today_date.month;                // get the current month
    var day = today_date.day;                    // get the current day
    this.firstDate = year + "-" + month + "-" + day;
    var last_date = element.expiry_day;
    var sdates = element.expiry_day.split("-", 3);
    var syear: number = +sdates[2];             // get the expiry_date year
    var smonth: number = +sdates[1];            // get the expiry_date month
    var sday: number = +sdates[0];              // get the expiry_date day
    const SDate: NgbDate = new NgbDate(sday, smonth, syear);     // get the expiry_date ngdate formate
    var year1 = SDate.year;
    var month1 = SDate.month;
    var day1 = SDate.day;
    this.secondDate = day1 + "-" + month1 + "-" + year1;
    if (new Date(this.firstDate).getTime() > new Date(this.secondDate).getTime()) {        //checking on date comparison
      this.falg = true;         // display normal color 
    }
    else {
      this.falg = false;        // display red color 
    }
  })
}
// generate pdf
downloadPdf(item) {                          // download image work by harish
  var id = "ticket_id";
  var url = "generate_pdf/?";
  console.log(btoa(item),"btoa(item)")
  var value = btoa(item);
  this.ajax.getPdfDocument(url, id, value).subscribe((response) => {
    let a = document.createElement("a")                   // new code for download pdf work by harish
    a.download = response.url;           
    a.href = response.url;
    a.click();
  }, (err) => {
    console.log(err); 
  });
}
}
